/* @flow */
const Avatars = {
  americanhistory: 'https://remind.imgix.net/3c0c0765-8575-4962-9fc2-c0c17b5c4a1b/americanhistory.svg',
  apple: 'https://remind.imgix.net/09be2cf3-2b09-4d0f-9616-938d73435a5a/apple.svg',
  art: 'https://remind.imgix.net/00b2b954-ad35-4705-b453-85f3befb5ba0/art.svg',
  baseball: 'https://remind.imgix.net/d38195f5-bcc9-4d16-899b-40a9a29d8c4e/baseball.svg',
  basketball: 'https://remind.imgix.net/dcd770e7-ea3a-40fc-b1c0-cb3843c6869c/basketball.svg',
  chemistry: 'https://remind.imgix.net/75abca9b-cdda-4224-9862-b80e55a2d45f/chemistry.svg',
  chorus: 'https://remind.imgix.net/0a157e1c-2ff9-4f1c-9b12-2199d656892e/chorus.svg',
  dinosaur: 'https://remind.imgix.net/64b37f6c-5322-4560-b3a3-f147e4b5aea2/dinosaur.svg',
  earthscience: 'https://remind.imgix.net/5b25e78f-eb0d-4aa4-a25b-6c6f053a18eb/earthscience.svg',
  football: 'https://remind.imgix.net/1948465c-6dbe-4492-9868-0de3794a7c9c/football.svg',
  geography: 'https://remind.imgix.net/8fe6e8a7-59bd-48fc-b69f-601cc5e03be8/geography.svg',
  geometry: 'https://remind.imgix.net/8f36940a-de83-4099-984e-e1a1b5d8264d/geometry.svg',
  home_economics: 'https://remind.imgix.net/32ae1920-907d-42a4-b33f-91ea2f9dc43d/home_economics.svg',
  language: 'https://remind.imgix.net/bd9cab09-3210-4fed-b8d6-69ecdf3951d7/language.svg',
  literature: 'https://remind.imgix.net/f6c0a316-a0f6-494e-8fd3-891733348c52/literature.svg',
  math: 'https://remind.imgix.net/c05e0419-6d7e-4213-b330-e6ca692f099c/math.svg',
  music: 'https://remind.imgix.net/3b260bde-e512-4921-9fb1-1650b13ee5e2/music.svg',
  physics: 'https://remind.imgix.net/f497cb2a-4bc9-48d7-bd31-e6da0c1817e2/physics.svg',
  politics: 'https://remind.imgix.net/8ca96e64-8b7d-42ca-8d17-315f8fd686bf/politics.svg',
  reading: 'https://remind.imgix.net/07477444-667f-449d-a54f-c40b8d3f9915/reading.svg',
  rocket: 'https://remind.imgix.net/e3421d23-5dca-4952-a86e-3dc7c11c2593/rocket.svg',
  science: 'https://remind.imgix.net/7d78cc30-0722-4753-9668-346a60b3527b/science.svg',
  school: 'https://remind.imgix.net/a3ec6345-0f21-4bd8-97e7-7d8dd0f6da91/school.svg',
  soccer: 'https://remind.imgix.net/17bcc4a0-5e4a-43c3-a75e-ea30c45a1d01/soccer.svg',
  sports: 'https://remind.imgix.net/e3c35aa0-c9f4-4f59-920c-9cbd7c8a873a/sports.svg',
  stats: 'https://remind.imgix.net/75536adb-251f-411d-9902-d821cf3df31c/stats.svg',
  tech: 'https://remind.imgix.net/96379c73-6531-43f1-96ff-0182e9f6a0d2/tech.svg',
  theater: 'https://remind.imgix.net/922a1638-891c-4107-bf74-9e814d3d9ef0/theater.svg',
  track: 'https://remind.imgix.net/673af6cf-6c6f-4912-afd5-f13b7ffc2fef/track.svg',
  writing: 'https://remind.imgix.net/b809898f-2903-4217-8954-569f958c194f/writing.svg',
};

const keys = Object.keys(Avatars);

export function getAvatarUrlFromKey(key: number): ?string {
  const stringKey = '' + key;
  let index = 0;
  for (let i = 0, l = stringKey.length; i < l; i++) {
    index = (index + stringKey.charCodeAt(i)) % keys.length;
  }
  return Avatars[keys[index]];
}

export default Avatars;



// WEBPACK FOOTER //
// ./src/lib/Avatars.js